function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9513 6.385C15.92 6.30875 15.8737 6.24 15.8162 6.1825L10.8175 1.18375C10.76 1.12625 10.6913 1.08 10.615 1.04875C10.54 1.0175 10.4587 1 10.375 1H2.25C1.56125 1 1 1.56125 1 2.25V19.75C1 20.4387 1.56125 21 2.25 21H14.75C15.4388 21 16 20.4387 16 19.75V6.625C16 6.54125 15.9825 6.46 15.9513 6.385ZM11 3.13375L13.8663 6H11V3.13375ZM14.75 19.75H2.25V2.25H9.75V6C9.75 6.68875 10.3112 7.25 11 7.25H14.75V19.75Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.375 13.5C5.03 13.5 4.75 13.78 4.75 14.125V17.875C4.75 18.22 5.03 18.5 5.375 18.5C5.72 18.5 6 18.22 6 17.875V14.125C6 13.78 5.72 13.5 5.375 13.5Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.625 8.5C11.28 8.5 11 8.78 11 9.125V17.875C11 18.22 11.28 18.5 11.625 18.5C11.97 18.5 12.25 18.22 12.25 17.875V9.125C12.25 8.78 11.97 8.5 11.625 8.5Z",
  fill: "currentColor"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11C8.155 11 7.875 11.28 7.875 11.625V17.875C7.875 18.22 8.155 18.5 8.5 18.5C8.845 18.5 9.125 18.22 9.125 17.875V11.625C9.125 11.28 8.845 11 8.5 11Z",
  fill: "currentColor"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9513 6.385C15.92 6.30875 15.8737 6.24 15.8162 6.1825L10.8175 1.18375C10.76 1.12625 10.6913 1.08 10.615 1.04875C10.54 1.0175 10.4587 1 10.375 1H2.25C1.56125 1 1 1.56125 1 2.25V19.75C1 20.4387 1.56125 21 2.25 21H14.75C15.4388 21 16 20.4387 16 19.75V6.625C16 6.54125 15.9825 6.46 15.9513 6.385ZM11 3.13375L13.8663 6H11V3.13375ZM14.75 19.75H2.25V2.25H9.75V6C9.75 6.68875 10.3112 7.25 11 7.25H14.75V19.75Z",
  stroke: "currentColor",
  strokeWidth: 0.4
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.375 13.5C5.03 13.5 4.75 13.78 4.75 14.125V17.875C4.75 18.22 5.03 18.5 5.375 18.5C5.72 18.5 6 18.22 6 17.875V14.125C6 13.78 5.72 13.5 5.375 13.5Z",
  stroke: "currentColor",
  strokeWidth: 0.4
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.625 8.5C11.28 8.5 11 8.78 11 9.125V17.875C11 18.22 11.28 18.5 11.625 18.5C11.97 18.5 12.25 18.22 12.25 17.875V9.125C12.25 8.78 11.97 8.5 11.625 8.5Z",
  stroke: "currentColor",
  strokeWidth: 0.4
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11C8.155 11 7.875 11.28 7.875 11.625V17.875C7.875 18.22 8.155 18.5 8.5 18.5C8.845 18.5 9.125 18.22 9.125 17.875V11.625C9.125 11.28 8.845 11 8.5 11Z",
  stroke: "currentColor",
  strokeWidth: 0.4
});
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4909ccfa5dfd32f4e2bc498351239945.svg";
export { ForwardRef as ReactComponent };